import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProfessionalRfpProposalListLink } from '@/components/modules/pages/mypage/professional/List/ProfessionalRfpProposalList/ActionLink';
import { SmallTagRounded } from '@/components/ui/Tag/SmallTagRounded';
import { VIEW_REQUEST_PROPOSAL_REFUSE, VIEW_REQUEST_PROPOSAL_TODO, } from '@/utils/constants/viewRequest/proposal';
export const ProfessionalRfpProposalListProposalLink = (props) => {
    const { href, proposal } = props;
    if (proposal === VIEW_REQUEST_PROPOSAL_TODO.value) {
        return (_jsx(SmallTagRounded, Object.assign({ color: 'lightOrange', isKanjiTopFixed: true, size: 'sm' }, { children: "\u63D0\u6848\u4E88\u5B9A" })));
    }
    if (proposal === VIEW_REQUEST_PROPOSAL_REFUSE.value) {
        return (_jsx(SmallTagRounded, Object.assign({ color: 'gray', isKanjiTopFixed: true, size: 'sm' }, { children: "\u63D0\u6848\u8F9E\u9000" })));
    }
    return (_jsx(ProfessionalRfpProposalListLink, { badgeNumber: 0, color: 'navy', disabled: false, href: href, text: '登録する' }));
};
